export const mixinObject = <T extends object>(condition: boolean, mixin: T) => {
  if (condition) return mixin;
  return {};
};

export const mixinArray = <T extends any[]>(condition: boolean, mixin: T) => {
  if (condition) return mixin;
  return [];
};
